/**
 * Show stamp line-item property fields based on selected 內容行數 (1行/2行/3行).
 * Loaded only on item-a65f63b8bcc1a8 via snippets/stamp-line-fields.liquid.
 */
(function () {
  const LINE_OPTION_LABEL = "內容行數";
  const LINE_VALUE_RE = /^(\d+)行$/;

  function parseLineCountFromValue(value) {
    const m = String(value || "").trim().match(LINE_VALUE_RE);
    return m ? Number(m[1]) : null;
  }

  function getSelectedLineCount(sectionRoot) {
    const section =
      sectionRoot.closest(".shopify-section") ||
      sectionRoot.closest("[id^='shopify-section-']") ||
      document;

    const variantSelects = section.querySelector("variant-selects");
    if (variantSelects) {
      const fieldsets = variantSelects.querySelectorAll("fieldset");
      for (const fieldset of fieldsets) {
        const legend = fieldset.querySelector("legend");
        if (!legend || !legend.textContent.includes(LINE_OPTION_LABEL)) continue;
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) {
          const n = parseLineCountFromValue(checked.value);
          if (n) return n;
        }
        const select = fieldset.querySelector("select");
        if (select) {
          const n = parseLineCountFromValue(select.value);
          if (n) return n;
        }
      }
    }

    const radios = section.querySelectorAll('input[type="radio"]:checked');
    for (const radio of radios) {
      const n = parseLineCountFromValue(radio.value);
      if (n) return n;
    }

    return 1;
  }

  function applyLineCount(root, count) {
    const lineCount = Math.max(1, Math.min(3, count || 1));
    root.querySelectorAll("[data-stamp-line]").forEach((wrapper) => {
      const line = Number(wrapper.getAttribute("data-stamp-line"));
      const input = wrapper.querySelector("input");
      if (!input) return;
      const visible = line <= lineCount;
      wrapper.hidden = !visible;
      wrapper.style.display = visible ? "" : "none";
      input.disabled = !visible;
      if (!visible) {
        input.value = "";
        input.removeAttribute("required");
      } else {
        input.setAttribute("required", "required");
      }
    });
    root.dispatchEvent(new CustomEvent("stamp-lines-updated"));
  }

  function bindStampLines(root) {
    const update = () => applyLineCount(root, getSelectedLineCount(root));
    update();

    const section =
      root.closest(".shopify-section") ||
      root.closest("[id^='shopify-section-']") ||
      document;

    section.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (target.type === "radio" || target.tagName === "SELECT") update();
    });

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, () => update());
    }

    document.addEventListener("shopify:section:load", (event) => {
      if (event.target && event.target.contains(root)) update();
    });
  }

  function init() {
    document.querySelectorAll("[data-stamp-lines-root]").forEach(bindStampLines);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
